import { Container, Graphics, Text, TextStyle } from 'pixi.js';

export class SpectatorHUD {
  container: Container;
  private background: Graphics;
  private labelText: Text;
  private teamText: Text;
  private hintText: Text;
  private visible: boolean = false;

  constructor() {
    this.container = new Container();
    this.container.visible = false;

    this.background = new Graphics();
    this.background.roundRect(0, 0, 250, 70, 8);
    this.background.fill({ color: 0x000000, alpha: 0.7 });
    this.container.addChild(this.background);

    const labelStyle = new TextStyle({
      fontFamily: 'Arial',
      fontSize: 12,
      fill: '#9c27b0',
      fontWeight: 'bold',
    });

    this.labelText = new Text({ text: '👁️ SPECTATING', style: labelStyle });
    this.labelText.position.set(10, 8);
    this.container.addChild(this.labelText);

    const teamStyle = new TextStyle({
      fontFamily: 'Arial',
      fontSize: 18,
      fill: '#ffffff',
      fontWeight: 'bold',
    });

    this.teamText = new Text({ text: '', style: teamStyle });
    this.teamText.position.set(10, 28);
    this.container.addChild(this.teamText);

    const hintStyle = new TextStyle({
      fontFamily: 'Arial',
      fontSize: 10,
      fill: '#888888',
    });

    this.hintText = new Text({ text: 'Arrow keys to pan camera', style: hintStyle });
    this.hintText.position.set(10, 52);
    this.container.addChild(this.hintText);
  }

  show(): void {
    this.visible = true;
    this.container.visible = true;
  }

  hide(): void {
    this.visible = false;
    this.container.visible = false;
  }

  isVisible(): boolean {
    return this.visible;
  }

  updateCurrentTeam(teamName: string, teamColor: number): void {
    this.teamText.text = teamName;
    this.teamText.style.fill = `#${teamColor.toString(16).padStart(6, '0')}`;
  }

  setPosition(x: number, y: number): void {
    this.container.position.set(x, y);
  }
}
